import { useEffect, useRef } from 'react';

import RotateLeft from 'assets/icons/rotate-arrow-left.png';
import RotateRight from 'assets/icons/rotate-arrow-right.png';

import styles from './styles.module.scss';
import { Props } from './types';

const RotateControl = ({ onPrevClick, onNextClick }: Props) => {
  const prevTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const nextTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (prevTimer.current) {
        clearTimeout(prevTimer.current);
      }
      if (nextTimer.current) {
        clearTimeout(nextTimer.current);
      }
    };
  }, []);

  const resetHold = () => {
    if (prevTimer.current) {
      clearTimeout(prevTimer.current);
    }
    if (nextTimer.current) {
      clearTimeout(nextTimer.current);
    }
  };

  const handlePrevClick = () => {
    onPrevClick();
    prevTimer.current = setTimeout(handlePrevClick, 150);
  };

  const handleNextClick = () => {
    onNextClick();
    nextTimer.current = setTimeout(handleNextClick, 150);
  };

  return (
    <div className={styles.container}>
      <button
        className={styles.iconWrapper}
        onMouseDown={handlePrevClick}
        onMouseUp={resetHold}
        onMouseOut={resetHold}
      >
        <img src={RotateLeft} className={styles.icon} draggable={false} />
      </button>
      <button
        className={styles.iconWrapper}
        onMouseDown={handleNextClick}
        onMouseUp={resetHold}
        onMouseOut={resetHold}
      >
        <img src={RotateRight} className={styles.icon} draggable={false} />
      </button>
    </div>
  );
};

export default RotateControl;
